<button class="btn menu-btn" [class.icon-selected]="logoFileUrl" (click)="onBtnClick()">
  @if (!logoFileUrl) {
    <div class="d-flex align-items-center justify-content-center h-100">
      <i class="user-logo-i"></i>
    </div>
  }
  @if (logoFileUrl) {
    <img class="h-100 w-100" [src]="logoFileUrl" (error)="logoFileUrl = ''" />
  }
</button>
@if (showMenu) {
  <div>
    <div class="menu-container">
      <div class="profile-container">
        <div class="d-flex align-items-center">
          <div class="change-photo">
            <label class="user-logo-cover" (click)="onLogoClick()">
              <input class="d-none" type="file" (change)="onChangeIcon($event.target.files)" />
              {{ 'CHOOSE_IMAGE_BTN' | translate }}
            </label>
            <div class="user-logo-container">
              @if (!logoFileUrl) {
                <i class="user-logo-i"></i>
              }
              @if (logoFileUrl) {
                <img class="h-100 w-100" [src]="logoFileUrl" />
              }
            </div>
          </div>
          <div>
            <div class="company">{{ name }}</div>
            <div class="email">{{ email }}</div>
          </div>
        </div>
      </div>
      <ul>
        <li class="d-lg-none">
          <app-language-select [type]="languageSelectorType"></app-language-select>
        </li>
        <li>
          <a class="menu-item" routerLink="/dh/change-password">
            <img src="assets/icons/toolbar/lock.png" class="menu-item-icon lock-icon" />
            {{ 'CHANGE_PASSWORD_BTN' | translate }}
          </a>
        </li>
        <li>
          <a class="menu-item" routerLink="/dh/notification-setting">
            <img src="assets/icons/toolbar/notification-email.png" class="menu-item-icon" />
            {{ 'NOTIFICATION_SETTING.CONFIG_BTN' | translate }}
          </a>
        </li>
        @if (isAdmin) {
          <li>
            <a class="menu-item" (click)="onOpenLicenseSidebar()">
              @if (hasBreachedLimits) {
                <i
                  class="fa-solid fa-triangle-exclamation limits-maxed-out-indicator"
                  [attr.title]="'LICENSE_LIMIT.LIMITS_BREACHED_ICON' | translate"
                  aria-hidden="true"
                  ><span class="screen-reader-only">{{ 'LICENSE_LIMIT.LIMITS_BREACHED_ICON' | translate }}</span></i
                  >
                  }<i class="fa-thin fa-file-certificate license-icon menu-item-icon" [attr.title]="'LICENSE_LIMIT.LICENSES_ICON' | translate"
                  ><span class="screen-reader-only">{{ 'LICENSE_LIMIT.LICENSES_ICON' | translate }}</span></i
                  >
                  {{ 'LICENSE_LIMIT.LICENSE' | translate }}
                </a>
              </li>
            }
            <li>
              <a class="menu-item" (click)="logout()">
                <img src="assets/icons/toolbar/logout.png" class="menu-item-icon" />
                {{ 'LOGOUT_BTN' | translate }}
              </a>
            </li>
          </ul>
        </div>
      </div>
    }

    <ng-template #licenseSidebar>
      <div class="license-sidebar-content">
        <h2>{{ 'LICENSE_LIMIT.LICENSE' | translate }}</h2>
        <p>
          {{ 'LICENSE_LIMIT.DESCRIPTION' | translate }}
        </p>
        @if (hasBreachedLimits && limitsComparison) {
          <app-information-block
            [mode]="'bubble'"
            [status]="'error'"
            [text]="'LICENSE_LIMIT.ONE_OR_MULTIPLE_LIMITS_BREACHED' | translate"
          ></app-information-block>
        }
        @if (limitsComparison) {
          <div>
            <ul class="limits-comparison-list">
              <li class="limits-comparison-list__item" [ngClass]="{ 'limits-comparison-list__item--limit-breached': !!breachedLimits.dwelling }">
                <span class="limits-comparison-list__level">{{ limitsComparison.dwellingLevel }} </span>
                {{ 'LICENSE_LIMIT.OF' | translate }}
                <span [ngClass]="{ 'limits-comparison-list__level': !!breachedLimits.dwelling }">{{
                  'LICENSE_LIMIT.MAX_LIMIT' | translate: { limit: limitsComparison.dwellingLimit ?? 0 }
                }}</span>
                {{ limitsComparison.dwellingLimit === 1 ? ('LICENSE_LIMIT.DWELLING' | translate) : ('LICENSE_LIMIT.DWELLINGS' | translate) }}
              </li>
              <li class="limits-comparison-list__item" [ngClass]="{ 'limits-comparison-list__item--limit-breached': !!breachedLimits.parking }">
                <span class="limits-comparison-list__level">{{ limitsComparison.parkingLevel }} </span>
                {{ 'LICENSE_LIMIT.OF' | translate }}
                <span [ngClass]="{ 'limits-comparison-list__level': !!breachedLimits.parking }">{{
                  'LICENSE_LIMIT.MAX_LIMIT' | translate: { limit: limitsComparison.parkingLimit ?? 0 }
                }}</span>
                {{
                limitsComparison.parkingLimit === 1 ? ('LICENSE_LIMIT.PARKING_SPACE' | translate) : ('LICENSE_LIMIT.PARKING_SPACES' | translate)
                }}
              </li>
              <li
                class="limits-comparison-list__item"
                [ngClass]="{ 'limits-comparison-list__item--limit-breached': !!breachedLimits.otherObject }"
                >
                <span class="limits-comparison-list__level">{{ limitsComparison.otherObjectLevel }} </span>
                {{ 'LICENSE_LIMIT.OF' | translate }}
                <span [ngClass]="{ 'limits-comparison-list__level': !!breachedLimits.otherObject }">{{
                  'LICENSE_LIMIT.MAX_LIMIT' | translate: { limit: limitsComparison.otherObjectLimit ?? 0 }
                }}</span>
                {{
                limitsComparison.otherObjectLimit === 1
                ? ('LICENSE_LIMIT.OTHER_OBJECT' | translate)
                : ('LICENSE_LIMIT.OTHER_OBJECTS' | translate)
                }}
              </li>
              <li
                class="limits-comparison-list__item"
                [ngClass]="{ 'limits-comparison-list__item--limit-breached': !!breachedLimits.premisesSqm }"
                >
                <span class="limits-comparison-list__level">{{ limitsComparison.premisesSqmLevel }} </span>
                {{ 'LICENSE_LIMIT.OF' | translate }}
                <span [ngClass]="{ 'limits-comparison-list__level': !!breachedLimits.premisesSqm }">{{
                  'LICENSE_LIMIT.MAX_LIMIT' | translate: { limit: limitsComparison.premisesSqmLimit ?? 0 }
                }}</span>
                {{ 'LICENSE_LIMIT.PREMISES_SQM' | translate }}
              </li>
            </ul>
          </div>
        }

        <app-information-block [mode]="'bubble'" [status]="'info'" [text]="'LICENSE_LIMIT.ROUND_UP_INFO' | translate"></app-information-block>
      </div>
    </ng-template>
